import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser({ ...res.data.user, has_key: false });
        const intended = sessionStorage.getItem("dap_redirect");
        sessionStorage.removeItem("dap_redirect");
        const dest = intended || "/dashboard";
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    if (sessionId) run();
    else navigate("/", { replace: true });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[#5C5A54]">
      <span className="font-serif-dl text-2xl">Sealing your session…</span>
    </div>
  );
}
